import { createAppStore } from '@store/createAppStore';
import { produce } from 'solid-js/store';

import { DialogState } from './types';

const [dialogBoxStore, setDialogBoxStore] = createAppStore<DialogState>(
  {
    dialogIds: [],
  },
  'dialogBoxStore',
);

export const openDialogBox = (dialogId: string) => {
  setDialogBoxStore(
    produce((draft) => {
      draft.dialogIds.push(dialogId);
    }),
  );
};

export const closeDialogBox = (dialogId: string) => {
  setDialogBoxStore(
    produce((draft) => {
      draft.dialogIds = draft.dialogIds.filter((id) => id !== dialogId);
    }),
  );
};

export const checkIfDialogBoxIsOpen = (dialogId: string) => {
  return dialogBoxStore.dialogIds.includes(dialogId);
};

export { dialogBoxStore };
export default { dialogBoxStore, openDialogBox, closeDialogBox };
